module.exports = __webpack_public_path__ + "static/media/ic_head3.c04f05d7.png";